<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Zone</h4>
            </li>
           
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row">
      <div class="col-6">

        <button mat-fab color="primary" (click)="registerZone()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> ID</th>
            <td mat-cell *matCellDef="let element;let i = index"> {{i+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.name}}
                </div>
               
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="union">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;" > Union Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.union_name}}
                </div>
                <div class="col">
                  <mat-icon (click)="editZone(element)">edit</mat-icon>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="col-5" *ngIf="zoneService.is_display_zone_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideZoneRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-zone-register></app-zone-register>
      </div>
    </div>
  </div>
</section>
